import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useBoolean, useOnClickOutside } from 'usehooks-ts';
import { Box, IconButton } from '@mui/material';

import * as routes from 'router/routes';
import { logout } from 'store/entities/users/slice';
import { MenuPanel, menuStyles } from 'components/simple';
import { LogoutIcon, PersonIcon } from 'assets/icons';
import { AccountSettingsIcon } from 'assets/menuIcons';

const styles = {
  root: {
    position: 'relative',
  },
  avatar: {
    padding: 0,
  },
  menu: {
    position: 'absolute',
    top: '55px',
    right: 0,
    zIndex: 2,
    minWidth: { xs: 230, md: 298 },
  },
};

const ProfileDropDown = () => {
  const { value: open, setFalse: setOpenFalse, toggle: toggleOpen } = useBoolean();
  const dispatch = useDispatch();
  const history = useHistory();

  const ref = useRef(null);

  useOnClickOutside(ref, setOpenFalse);

  const handleAccountSettings = () => {
    setOpenFalse();
    history.push(routes.accountSettings);
  };

  const handleLogout = () => {
    setOpenFalse();
    dispatch(logout());
  };

  const menuOptions = [
    {
      key: 'account-settings',
      label: 'Account Settings',
      icon: <AccountSettingsIcon aria-hidden="true" />,
      onClick: handleAccountSettings,
    },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutIcon aria-hidden="true" />,
      onClick: handleLogout,
    },
  ];

  return (
    <Box className="remove_for_pdf" sx={styles.root} ref={ref}>
      <IconButton
        type="button"
        aria-label="User menu"
        aria-expanded={open}
        aria-haspopup="true"
        aria-controls="profile-dropdown-menu"
        sx={styles.avatar}
        onClick={toggleOpen}
      >
        <PersonIcon aria-hidden="true" />
      </IconButton>

      {open && (
        <Box sx={[menuStyles.panel, styles.menu]} id="profile-dropdown-menu">
          <MenuPanel options={menuOptions} />
        </Box>
      )}
    </Box>
  );
};

export default ProfileDropDown;
